import {
  AmountCell,
  Badge,
  CountCell,
  DateCell,
  IdCell,
  NameCell,
  PhoneCell,
  SubduedCell,
} from "@";

// TanStack table column definitions for the detailed donations report
const tableColumns = [
  {
    id: "id",
    header: "رقم العملية",
    size: 110,
    cell: ({ row }) => <IdCell value={row.original.id} />,
  },
  {
    id: "userName",
    header: "إسم المتبرع",
    size: 180,
    cell: ({ row }) => <NameCell name={row.original.userName} />,
  },
  {
    id: "phoneNumber",
    header: "رقم الجوال",
    size: 140,
    cell: ({ row }) => <PhoneCell phone={row.original.phoneNumber} />,
  },
  {
    id: "projectTitle",
    header: "عنوان المشروع",
    size: 180,
    cell: ({ row }) => <NameCell name={row.original.projectTitle} />,
  },
  {
    id: "classification",
    size: 110,
    header: "التصنيف",
    cell: ({ row }) => <SubduedCell value={row.original.classification} />,
  },
  {
    id: "attributeName",
    header: "الفئة",
    size: 130,
    cell: ({ row }) => <SubduedCell value={row.original.attributeName} />,
  },
  {
    id: "count",
    header: "عدد الأسهم",
    size: 100,
    cell: ({ row }) => <CountCell value={row.original.count} label="سهم" />,
  },
  {
    id: "totalAmount",
    header: "مبلغ التبرع",
    size: 100,
    cell: ({ row }) => (
      <AmountCell value={row.original.totalAmount} tone="purple" />
    ),
  },
  {
    id: "paymentType",
    header: "وسيلة التبرع",
    size: 130,
    cell: ({ row }) => (
      <Badge
        title={row.original.paymentType === 0 ? "بطاقة" : "تحويل بنكي"}
        color={row.original.paymentType === 0 ? "default" : "dark"}
      />
    ),
  },
  {
    id: "bankAccountName",
    header: "الحساب البنكي",
    size: 160,
    cell: ({ row }) => <SubduedCell value={row.original.bankAccountName} />,
  },
  {
    id: "createdOn",
    header: "التاريخ",
    size: 130,
    cell: ({ row }) => <DateCell value={row.original.createdOn} />,
  },
];

export default tableColumns;
